import { useState } from "react";
import { api, errorText, type User } from "../lib/api.ts";

export function LoginPage({ onLogin }: { onLogin: (u: User) => void }) {
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const login = async () => {
    setBusy(true);
    setError(null);
    try {
      onLogin(await api.login());
    } catch (err) {
      setError(errorText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="center">
      <div className="card">
        <div style={{ display: "flex", justifyContent: "center", marginBottom: "16px" }}>
          <img src="/logo.png" alt="racler.dev" width="64" height="64" style={{ borderRadius: "14px" }} />
        </div>
        <h1>racler.dev</h1>
        <p className="muted">Sign in with your passkey.</p>
        <button className="primary" disabled={busy} onClick={() => void login()} data-testid="login">
          {busy ? "Waiting for passkey…" : "Sign in with passkey"}
        </button>
        {error && <p className="error">{error}</p>}
        <p className="muted small">
          Works with Touch ID, Face ID, Windows Hello, Android, password managers, security keys or a phone
          nearby. Registration is invite-only.
        </p>
      </div>
    </div>
  );
}
